import isEmpty from 'lodash/isEmpty';
import env from '@byted/ecom-mobile-lib/lib/core/env';
import { get } from 'libs/request';
import { genGetURL } from 'src/utils/common-func';
import { sendPrefetchActionStatus, sendPrefetchActionFailed } from 'services/product/tecEvent';
import { API_EC, API_KEN } from 'config/host';
import { ge } from 'libs/semver';

interface PrefetchOrderInfoProps {
    productId: number;
    skuId: number;
    originType: string;
    pageId: string;
    addr_id1?: string;
    addr_id2?: string;
    addr_id3?: string;
    addr_id4?: string;
}

enum CachedMap {
    fallback, // 取自缓存
    pending, // 取自pending中的数据
    cache // 取自缓存
}

const USE_PREFETCH_CONDITION = env.isInAweme && ge(env.appVersion, '11.2.0');

function prefetchAction({ method = 'GET', params = {}, url = '' }, fallbackAction: () => {}) {
    const initTime = Date.now();
    const props: any = {
        url, // 这里的url必须传入完整url
        method
    };
    if (method === 'POST') {
        props.data = params;
    } else {
        props.params = params;
    }

    return new Promise((resolve: (arg0: any) => void) => {
        const ToutiaoJSBridge = window.ToutiaoJSBridge;
        // 异常处理 以及 安卓走原逻辑(安卓基于bridge2.0版本才支持, ecom-mobile-lib是1.0 包袱比较重 先不动)
        if (!ToutiaoJSBridge || env.isAndroid) {
            resolve(fallbackAction());
        }

        ToutiaoJSBridge.call('__prefetch', props, ({ code, raw, cached }) => {
            // 上报数据预取成功失败率
            sendPrefetchActionStatus({
                url,
                status: cached,
                time: Date.now() - initTime
            });

            // 降级处理
            if (isEmpty(raw)) {
                sendPrefetchActionFailed({
                    url,
                    status: cached
                });
                resolve(fallbackAction());
            }

            resolve({
                code,
                data: raw,
                fromPrefetch: true
            });
        });
    });
}

export const prefetchGetOrderInfoAction = ({
    productId,
    skuId,
    originType,
    pageId,
    ...reset
}: PrefetchOrderInfoProps): Promise<any> => {
    const defaultAction = () =>
        get(
            genGetURL(
                `${API_EC}/product/getorderinfo?id=${productId}&sku_id=${skuId}&origin_type=${originType}${
                    pageId ? `&page_id=${pageId}` : ''
                }`,
                reset
            )
        );
    if (USE_PREFETCH_CONDITION) {
        return prefetchAction(
            {
                params: {
                    id: productId,
                    sku_id: skuId,
                    origin_type: originType,
                    page_id: pageId,
                    // aweme flag
                    b_type_new: env.bType,
                    ...reset
                },
                url: `${API_EC}/product/getorderinfo`
            },
            defaultAction
        );
    }
    return defaultAction();
};

interface PrefetchDetailInfoProps {
    id: string;
    originId: string;
    originType: string;
}

export const prefetchGetProductDetail = ({
    id,
    originId,
    originType
}: PrefetchDetailInfoProps): Promise<any> => {
    const params = {
        id,
        originId,
        originType,
        b_type_new: env.bType
    };
    const URL = `${API_KEN}/product/getProductDetail`;

    const defaultAction = () =>
        get(URL, {
            params
        });

    if (USE_PREFETCH_CONDITION) {
        return prefetchAction(
            {
                params,
                url: URL
            },
            defaultAction
        );
    }
    return defaultAction();
};

/**
 * 提单页初始接口
 * @param PrefetchOrderInfoProps
 */
export const prefetchGetBuyNow = ({
    productId,
    skuId,
    originType,
    pageId
}: PrefetchOrderInfoProps): Promise<any> => {
    const defaultAction = () =>
        get(
            `${API_KEN}/pack/product/buynow?productId=${productId}&skuId=${skuId}&originType=${originType}${
                pageId ? `&pageId=${pageId}` : ''
            }`
        );
    if (USE_PREFETCH_CONDITION) {
        return prefetchAction(
            {
                params: {
                    productId,
                    skuId,
                    originType,
                    pageId,
                    b_type_new: env.bType
                },
                url: `${API_KEN}/pack/product/buynow`
            },
            defaultAction
        );
    }
    return defaultAction();
};
